import "./App.css";
import Theme from "./theme";
import "./assets/css/common.css";
import { setStorageData } from "./utils/helper";
import { useEffect } from "react";
import { DOMAIN_CLINKS } from "constants/app";
function App() {
  const domain = window.location.hostname;
  setStorageData("domain", domain);

  useEffect(() => {
    if (DOMAIN_CLINKS === domain) {
      document.title = "Clinks | Directory Provided by Make Time Count Today";
      const link = document.querySelector("link[rel~='icon']");
      link.href = "/clinksFavicon.png";
    } else {
      document.title = "Make Time Count Today | We all need help sometimes";
      const link = document.querySelector("link[rel~='icon']");
      link.href = "/mtcFavicon.ico";
    }
  }, []);

  return <Theme />;
}

export default App;
